import { ApiResponse } from 'apisauce';

import { ImageType, UploadImageDTO } from '@models/Image';

import { createAdminApi, getImageManagerBaseUrl } from '../shared/utils';

const api = createAdminApi(getImageManagerBaseUrl(), { 'x-api-version': '1.0' });

const getFormData = (imgFile: Blob | File, CreateAspectRatios?: ImageType[]) => {
  const formData = new FormData();
  formData.append('File', imgFile);

  if (CreateAspectRatios && CreateAspectRatios.length > 0)
    formData.append('request', JSON.stringify({ CreateAspectRatios }));

  return formData;
};

export type UploadImageFunc = (
  imageType: ImageType,
  imgFile: Blob | File,
  createAspectRatios?: ImageType[],
  id?: string
) => Promise<ApiResponse<undefined | UploadImageDTO>>;

export const uploadImage: UploadImageFunc = (imageType, imgFile, createAspectRatios, id) =>
  api.post<UploadImageDTO>(
    ['editorial', ...(id ? [id] : []), imageType].join('/'),
    getFormData(imgFile, createAspectRatios)
  );

export const uploadTitleImageScopedToCollection = (
  masterId: string,
  collectionId: string,
  imageType: ImageType,
  imgFile: Blob | File,
  createAspectRatios?: ImageType[]
) =>
  api.post<undefined>(
    `titles/${masterId}/collections/${collectionId}/${imageType}`,
    getFormData(imgFile, createAspectRatios)
  );

export const deleteCollectionScopedImage = (
  masterId: string,
  collectionId: string,
  imageType: ImageType
) => api.delete(`titles/${masterId}/collections/${collectionId}/${imageType}`);
